import './App.css';
import React, { Fragment, useEffect } from "react";
import Router from "./components/router";
import { ToastContainer } from 'react-toastify';
import { useThunk } from './hooks/useThunk';
import { fetchProfile } from './store';
import { useSelector } from 'react-redux';

function App() {
  const [doFetchProfile] = useThunk(fetchProfile);
  const { isAuthenticated } = useSelector((state) => state.auth);


  useEffect(() => {
    if (isAuthenticated) {
      doFetchProfile();
    }
  }, [isAuthenticated, doFetchProfile]);

  return (
    <Fragment>
      <ToastContainer limit={1} />
      <Router />
    </Fragment>
  );
}

export default App;
